import { VDP_SEARCH_LIST_KEY } from 'constants/marketplace';
import { normalizeVehicleId } from './vehicles';

export const getVdpDetailsContext = (state, meta) => ({
	vdpList: state.searchLists[VDP_SEARCH_LIST_KEY],
	vehicleId: normalizeVehicleId(meta.arg.vehicleId),
});

export const isCurrentVdpDetailsRequest = ({ vdpList, vehicleId }, requestId) =>
	vdpList.vehicleIds[0] === vehicleId && vdpList.detailsRequestStatus.requestId === requestId;
